import React from 'react';
import Layout from '../components/Layout';
import '../styles/service-page.css';

const PlantUMLService = ({ user }) => {
  return (
    <Layout>
      <div className="container service-page">
        <div className="page-heading">
          <h1>PlantUML Service</h1>
          <p>Professional diagram creation using PlantUML syntax with AI assistance. Perfect for technical documentation, system design, and architectural blueprints.</p>
        </div>

        <div className="service-content">
          <div className="overview-section">
            <h2>PlantUML Expertise</h2>
            <p>PlantUML is the industry standard for creating technical diagrams as code. Our service combines the power of PlantUML with intelligent AI assistance to help you create professional diagrams faster and more accurately.</p>
          </div>

          <div className="diagram-types">
            <h2>Supported Diagram Types</h2>
            <div className="types-grid">
              <div className="type-item">
                <h3>Sequence Diagrams</h3>
                <p>Document interactions between objects over time. Perfect for API documentation and system behavior modeling.</p>
              </div>
              <div className="type-item">
                <h3>Class Diagrams</h3>
                <p>Visualize object-oriented designs, showing classes, attributes, methods, and relationships.</p>
              </div>
              <div className="type-item">
                <h3>Component Diagrams</h3>
                <p>Illustrate the organization and dependencies among software components.</p>
              </div>
              <div className="type-item">
                <h3>Deployment Diagrams</h3>
                <p>Show the physical deployment of artifacts on nodes in your system architecture.</p>
              </div>
              <div className="type-item">
                <h3>Use Case Diagrams</h3>
                <p>Capture functional requirements and user interactions with your system.</p>
              </div>
              <div className="type-item">
                <h3>Activity Diagrams</h3>
                <p>Model workflows, business processes, and algorithmic logic flows.</p>
              </div>
            </div>
          </div>

          <div className="benefits-section">
            <h2>Why Choose Our PlantUML Service?</h2>
            <div className="benefits-list">
              <div className="benefit">
                <h3>AI-Enhanced Creation</h3>
                <p>Our AI understands PlantUML syntax and best practices, helping you create better diagrams with less effort.</p>
              </div>
              <div className="benefit">
                <h3>Version Control Ready</h3>
                <p>PlantUML diagrams are text-based, making them perfect for Git workflows and collaborative development.</p>
              </div>
              <div className="benefit">
                <h3>Professional Output</h3>
                <p>Generate high-quality SVG, PNG, and PDF outputs suitable for documentation and presentations.</p>
              </div>
              <div className="benefit">
                <h3>Integration Friendly</h3>
                <p>Easily integrate with wikis, documentation systems, and CI/CD pipelines.</p>
              </div>
            </div>
          </div>

          <div className="cta-section">
            <h2>Ready to Get Started?</h2>
            <p>Transform your technical documentation with professional PlantUML diagrams. Our AI-powered service makes complex diagram creation simple and efficient.</p>
            <button className="cta-button">Start Creating PlantUML Diagrams</button>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default PlantUMLService;